import { isDevMode } from '../../../../@controls/utils';
import { getPublicKeys } from '@controls/utils/env';

export const defaultLanguage = getPublicKeys()?.publicKeys?.DEFAULT_LOCALE
  ? getPublicKeys()?.publicKeys?.DEFAULT_LOCALE
  : isDevMode()
    ? 'fr'
    : 'en';
export const defaultNs = 'common';
